import React from 'react';
import moment from 'moment';
import '../styles.scss';
import { Button, Form, Input, InputNumber, message, Radio, Space, TimePicker, Tooltip } from 'antd';
import { Api } from '../../../lib/api';

const TimePickerFormat = 'HH:mm';
const InputNumberFilter = /^[0-9\b]+$/;

export default class System extends React.PureComponent {
    state = {
        systemTime: null,
        isCableAssembly: null,
        backupSettings: {
            backupPath: null,
            backupFrequency: null,
            backupTime: { hour: null, minute: null },
            backupDay: null,
            numberOfBackups: null
        },
        savedBackupSettings: {
            backupPath: null,
            backupFrequency: null,
            backupTime: { hour: null, minute: null },
            backupDay: null,
            numberOfBackups: null
        },
        key: 0
    };

    componentDidMount() {
        this.getSystem();
        if (localStorage.getItem('role') === 'admin') {
            this.getDatabaseBackupSettings();
        }
    }

    getSystem() {
        Api.getSystem()
            .then((value) => {
                this.setState({
                    systemTime: value.systemTime,
                    isCableAssembly: value.isCableAssembly
                });
            });
    }

    getDatabaseBackupSettings = async () => {
        return Api.getDatabaseBackupSettings()
            .then((value) => {
                this.setState({
                    backupSettings: {
                        backupPath: value.path,
                        backupFrequency: value.frequency,
                        backupTime: { hour: value.time.hour, minute: value.time.minute },
                        backupDay: value.day,
                        numberOfBackups: value.number
                    },
                    savedBackupSettings: {
                        backupPath: value.path,
                        backupFrequency: value.frequency,
                        backupTime: { hour: value.time.hour, minute: value.time.minute },
                        backupDay: value.day,
                        numberOfBackups: value.number
                    },
                    key: (this.state.key + 1) % 2
                });
            });
    }

    setDatabaseBackupSettings = () => {
        Api.updateDatabaseBackupSettings(
            this.state.backupSettings.backupPath,
            this.state.backupSettings.backupFrequency,
            this.state.backupSettings.backupTime,
            this.state.backupSettings.backupDay,
            this.state.backupSettings.numberOfBackups)
            .then(() => {
                // Update the settings.
                this.getDatabaseBackupSettings()
                    .then(() => {
                        // Display the success message.
                        message.success("Database backup settings saved!", 10);
                    });
            })
            .catch((ex) => {
                // Log the error.
                console.log(ex);
                // Display the error message.
                message.error(ex.message, 10);
            });
    }

    updateBackupPath = async (e) => {
        let value = '';
        if (e.hasOwnProperty('target')) {
            value = e.target.value;
        } else {
            value = e;
        }
        this.setState(previousState => ({
            backupSettings: {
                ...previousState.backupSettings,
                backupPath: value
            }
        }));
    }

    updateBackupFrequency = (e) => {
        this.setState(previousState => ({
            backupSettings: {
                ...previousState.backupSettings,
                backupFrequency: e.target.value
            }
        }));
    }

    updateBackupTime = (e) => {
        if (e !== null) {
            this.setState(previousState => ({
                backupSettings: {
                    ...previousState.backupSettings,
                    backupTime: { hour: e.format("HH"), minute: e.format("mm") }
                }
            }));
        }
    }

    updateBackupDay = (e) => {
        this.setState(previousState => ({
            backupSettings: {
                ...previousState.backupSettings,
                backupDay: e.target.value
            }
        }));
    }

    updateBackupNumber = (e) => {
        this.setState(previousState => ({
            backupSettings: {
                ...previousState.backupSettings,
                numberOfBackups: e
            }
        }));
    }

    isBackupSettingsChanged() {
        if (this.state.backupSettings.backupPath !== this.state.savedBackupSettings.backupPath) {
            return true;
        }
        if (this.state.backupSettings.backupFrequency !== this.state.savedBackupSettings.backupFrequency) {
            return true;
        }
        if ((this.state.backupSettings.backupTime.hour !== this.state.savedBackupSettings.backupTime.hour) ||
            (this.state.backupSettings.backupTime.minute !== this.state.savedBackupSettings.backupTime.minute)) {
            return true;
        }
        if (this.state.backupSettings.backupDay !== this.state.savedBackupSettings.backupDay) {
            return true;
        }
        if (this.state.backupSettings.numberOfBackups !== this.state.savedBackupSettings.numberOfBackups) {
            return true;
        }
        return false;
    }

    validateForm() {
        if (this.state.backupSettings.backupPath === "") {
            return false;
        }
        return true;
    }

    showDirectoryPicker = async () => {
        try {
            if ("showDirectoryPicker" in window) {
                const dirHandle = await window.showDirectoryPicker();
                this.updateBackupPath(dirHandle.name)
                    .then(() => {
                        this.setState({
                            key: (this.state.key + 1) % 2
                        });
                    });
            }
        } catch (ex) {
            // An AbortError occurs if user closes the directory picker window.
            if (ex.name !== "AbortError") {
                console.log(ex);
            }
        }
    }

    render() {
        return (
            <div className="section page-card">
                <div className="label">Displayed Time:</div>
                <Radio.Group
                    buttonStyle="solid"
                    value={this.state.systemTime}
                    onChange={(e) => {
                        Api.updateSystem(e.target.value, this.state.isCableAssembly).then((value) => {
                            if (value) {
                                this.setState({ systemTime: e.target.value });
                            } else {
                                alert('service error');
                            }
                        });
                    }}
                >
                    <Tooltip
                        placement="top"
                        title={
                            <div className="tooltip">
                                Show measurement dates in Universal Coordinated Time. Results are always saved in this format
                            </div>
                        }
                    >
                        <Radio.Button value={1}>UTC</Radio.Button>
                    </Tooltip>
                    <Tooltip
                        placement="top"
                        title={
                            <div className="tooltip">
                                Show measurement dates in Local Time. This will affect the databrowser displayed time only
                            </div>
                        }
                    >
                        <Radio.Button value={2}>Local</Radio.Button>
                    </Tooltip>
                </Radio.Group>

                <div className="cable-assembly-check">
                    <div className="label">Export from PC Only:</div>
                    <Radio.Group
                        buttonStyle="solid"
                        value={this.state.isCableAssembly}
                        onChange={(e) => {
                            Api.updateSystem(this.state.systemTime, e.target.value).then((value) => {
                                if (value) {
                                    this.setState({ isCableAssembly: e.target.value });
                                } else {
                                    alert('service error');
                                }
                            });
                        }}
                    >
                        <Tooltip
                            placement="top"
                            title={
                                <div className="tooltip">
                                    Improve system performance by disabling all printing and exports from XNS Stations{' '}
                                </div>
                            }
                        >
                            <Radio.Button value={true}>Enable</Radio.Button>
                        </Tooltip>
                        <Tooltip
                            placement="top"
                            title={<div className="tooltip">Allow print and export from PC software and XNS Stations</div>}
                        >
                            <Radio.Button value={false}>Disable</Radio.Button>
                        </Tooltip>
                    </Radio.Group>
                </div>

                {(localStorage.getItem('role') === 'admin') && (
                    <div className="database-backup-settings">
                        <hr/>
                        <div className="label">Database Backup Settings</div>
                        
                        <Form
                            key={this.state.key} // update form default values after component mount
                        >
                            <Form.Item className="backup-path">
                                <Space.Compact>
                                    <Form.Item
                                        name="path"
                                        label={"Backup Path"}
                                        initialValue={this.state.backupSettings.backupPath}
                                        rules={[{ required: true, message: 'Please input the backup path!' }]}
                                    >
                                        <Input className="backup-path-input" onChange={this.updateBackupPath} />
                                    </Form.Item>
                                    {("showDirectoryPicker" in window) && (
                                        <Tooltip
                                            placement="top"
                                            title={<div className="tooltip">Directory Picker</div>}
                                        >
                                            <Button htmlType="button" onClick={this.showDirectoryPicker}>...</Button>
                                        </Tooltip>
                                    )}
                                    {!("showDirectoryPicker" in window) && (
                                        <Tooltip
                                            placement="top"
                                            title={<div className="tooltip">No directory picker support on current browser.</div>}
                                        >
                                            <Button htmlType="button" disabled>...</Button>
                                        </Tooltip>
                                    )}
                                </Space.Compact>
                            </Form.Item>

                            <Form.Item
                                name="frequency"
                                label="Frequency of Backup"
                                initialValue={this.state.backupSettings.backupFrequency}
                            >
                                <Radio.Group
                                    buttonStyle="solid"
                                    onChange={this.updateBackupFrequency}
                                >
                                    <Radio.Button value="daily">Daily</Radio.Button>
                                    <Radio.Button value="weekly">Weekly</Radio.Button>
                                </Radio.Group>
                            </Form.Item>

                            <Form.Item
                                name="time"
                                label="Time of Backup"
                                initialValue={moment(
                                    this.state.backupSettings.backupTime.hour + ":" + this.state.backupSettings.backupTime.minute,
                                    TimePickerFormat)}
                            >
                                <TimePicker
                                    allowClear={false}
                                    inputReadOnly={true}
                                    format={TimePickerFormat}
                                    onChange={this.updateBackupTime} />
                            </Form.Item>

                            {(this.state.backupSettings.backupFrequency === "weekly") && (
                                <Form.Item
                                    name="day"
                                    label="Day of Backup"
                                    initialValue={this.state.backupSettings.backupDay}
                                >
                                    <Radio.Group
                                        buttonStyle="solid"
                                        onChange={this.updateBackupDay}
                                    >
                                        <Radio.Button value="monday">Monday</Radio.Button>
                                        <Radio.Button value="tuesday">Tuesday</Radio.Button>
                                        <Radio.Button value="wednesday">Wednesday</Radio.Button>
                                        <Radio.Button value="thursday">Thursday</Radio.Button>
                                        <Radio.Button value="friday">Friday</Radio.Button>
                                        <Radio.Button value="saturday">Saturday</Radio.Button>
                                        <Radio.Button value="sunday">Sunday</Radio.Button>
                                    </Radio.Group>
                                </Form.Item>
                            )}

                            <Form.Item
                                name="number"
                                label="Maximum Number of Backups"
                                initialValue={this.state.backupSettings.numberOfBackups}
                            >
                                <InputNumber
                                    min={1}
                                    max={20}
                                    onKeyDown={(event) => {
                                        if (!InputNumberFilter.test(event.key) && event.key !== 'Backspace') {
                                            event.preventDefault();
                                        }
                                    }}
                                    onChange={this.updateBackupNumber}
                                />
                            </Form.Item>
                            
                            <Form.Item>
                                <Tooltip
                                    placement="top"
                                    title={
                                        <div className="tooltip">
                                            Save changes to the database backup settings.
                                        </div>
                                    }
                                >
                                    <Button
                                        type="primary"
                                        htmlType="submit"
                                        onClick={this.setDatabaseBackupSettings}
                                        disabled={!this.isBackupSettingsChanged() || !this.validateForm()}
                                    >
                                        Save
                                    </Button>
                                </Tooltip>
                                <Tooltip
                                    placement="top"
                                    title={
                                        <div className="tooltip">
                                            Retrieve the current database backup settings.
                                        </div>
                                    }
                                >
                                    <Button htmlType="button" onClick={this.getDatabaseBackupSettings}>Reset</Button>
                                </Tooltip>
                            </Form.Item>
                        </Form>
                    </div>
                )}
            </div>
        );
    }
}